import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import type { SalesTrendResult, SalesTrendSettings } from '../common/types';

interface State {
  data: SalesTrendResult | null;
  loading: boolean;
  error: string | null;
}

/** Загрузка графика с отменой применения устаревшего ответа. */
export class SalesTrendWidgetController extends ControllerStore<State> {
  private version = 0;
  constructor(private getTrend: (settings: SalesTrendSettings) => Promise<SalesTrendResult>) {
    super({ data: null, loading: true, error: null });
  }
  async load(settings: SalesTrendSettings) {
    const version = ++this.version;
    this.setState({ data: null, loading: true, error: null });
    try {
      const data = await this.getTrend(settings);
      if (version === this.version) this.setState({ data, loading: false });
    } catch (error) {
      if (version === this.version)
        this.setState({
          loading: false,
          error: error instanceof Error ? error.message : 'Не удалось загрузить продажи',
        });
    }
  }
  cancelLoad() {
    this.version += 1;
  }
}
